import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import './donation.css';
import bank from '../../assets/images/image-30_1image 30.png';
import dialog from '../../assets/images/dialog_logo_1dialog_logo.png';

const CONTACT_US_API = 'https://cms.gammadda.lk/wp-json/custom/v1/contact-us';
const RECAPTCHA_SITE_KEY = '6LciAEEtAAAAAMEE2arJSEESw_vV55uT-71Wd_bS';

const Donation = () => {
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactForm, setContactForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = React.useRef(null);

  useEffect(() => {
    setShowContactModal(true);
  }, []);

  const handleCloseContactModal = () => {
    setShowContactModal(false);
    setSubmitStatus(null);
  };

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    if (!captchaToken) {
      setSubmitStatus('captcha-error');
      return;
    }
    setSubmitting(true);
    setSubmitStatus(null);
    try {
      await axios.post(CONTACT_US_API, { ...contactForm, 'g-recaptcha-response': captchaToken }, {
        headers: { 'Content-Type': 'application/json' },
      });
      setSubmitStatus('success');
      setContactForm({ name: '', email: '', phone: '', message: '' });
      setCaptchaToken(null);
      recaptchaRef.current?.reset();
    } catch (error) {
      setSubmitStatus('error');
      setCaptchaToken(null);
      recaptchaRef.current?.reset();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="background-color">
       <div id="projects" className="section">
      <div className="container">
        <h1 className="h1-left">Make a donation</h1>
        <p className="p-left">The donation will be added to the separate fund to which you have requested and will be directly monitored by our team and deploy it to reach the solution of the project. The website will be updated once in two weeks with the progress of the project and the progress of the donation.</p>
        <div className="make-a-transfer-heading">
          <img src={bank} loading="lazy" alt="" srcset="" />
          <h3 className="donation-page">Make a bank transfer</h3>
        </div>
        <div className="row">
          <div className="col-md-7 col-12">
            <p className="p-left">For both domestic and international transfers. To make a donation via bank wire transfer, use the information below.
              <br />
              <br />
              Contact: Customer Service  <br />
              Phone: +94 114 896 896  <br />
              Email: <a href="mailto:info@gammadda.lk">info@gammadda.lk</a></p>

          </div>
          <div className="who-we-are col-md-5 col-12">
            <p className="p-left bank-details">
              <strong className="bold-text-4">Hatton National Bank</strong><br />
              Bank Name: Hatton National Bank<br />
              Bank Branch: Head Office<br />
              Bank Account Number: 003010514477<br />
              SWIFT Code: HBLILKLX              
               <br /><br /><br />
               <strong className="bold-text-3">Bank of Ceylon</strong><br />
              Bank Name: Bank of Ceylon<br />
              Bank Branch: Corporate Branch<br />
              Bank Account Number: 80144512<br />
              SWIFT Code: BCEYLKLXXXX              
              <br /><br /><br />
              <strong className="bold-text-4">Nation’s Trust Bank</strong>
              <br />Bank Name: Nation&#x27;s Trust Bank<br />
              Bank Branch: Cinnamon Gardens<br />
              Bank Account Number: 100111112335<br />
              SWIFT Code: NTBCLKLXXXX
             
              
              </p>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="make-a-transfer-heading">
          <img src={dialog} loading="lazy" alt="" />
          <h3 className="donation-page">Donate through Dialog</h3>
        </div>
        <div className="row">
          <div className="col-md-7 col-12">
            <p className="p-left">It is easier for you to simply donate to Gammadda through your Dialog number. Simply follow the instructions.</p>
          </div>
          <div className="who-we-are col-md-5 col-12">
            <p className="p-left bank-details"><strong className="bold-text">Instructions:<br /></strong>‍<br />From your Dialog mobile type <strong>GAM</strong> &amp; send it to <strong>7788</strong></p>
          </div>
        </div>
      </div>
    </div>

    <Modal show={showContactModal} onHide={handleCloseContactModal} centered className="contact-us-modal">
      <Modal.Header closeButton>
        <Modal.Title>Contact Us Now</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {submitStatus === 'success' ? (
          <p className="contact-us-success mb-0">Thank you! Your message has been sent successfully.</p>
        ) : (
          <Form onSubmit={handleContactSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder='Enter your name'
                value={contactForm.name}
                onChange={handleContactChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder='Enter your email'
                value={contactForm.email}
                onChange={handleContactChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                placeholder='Enter your mobile number'
                value={contactForm.phone}
                onChange={handleContactChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="message"
                placeholder='Enter your message'
                value={contactForm.message}
                onChange={handleContactChange}
                required
              />
            </Form.Group>
            <div className="mb-3 contact-us-captcha">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={(token) => {
                  setCaptchaToken(token);
                  setSubmitStatus(null);
                }}
                onExpired={() => setCaptchaToken(null)}
              />
            </div>
            {submitStatus === 'captcha-error' && (
              <p className="contact-us-error">Please verify that you are human.</p>
            )}
            {submitStatus === 'error' && (
              <p className="contact-us-error">Something went wrong. Please try again.</p>
            )}
            <div className="text-end">
              <Button type="submit" className="contact-us-submit-btn" disabled={submitting}>
                {submitting ? 'Sending...' : 'Send'}
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
    </div>

  )
}

export default Donation